import { Modal, Button } from 'react-bootstrap';
import { ISerologyTest } from '@nkr/models/index';

interface IProps {
    show: boolean,
    centerRequiresQfg: boolean,
    serologTestList: ISerologyTest[],
    onClose: () => void
}

const SerologyTests = (props: IProps) => {
    return (
        <Modal show={props.show} backdrop='static' onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Required Serology Testing</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ol>
                    {props.serologTestList.map((test, index) =>
                        <li key={`t-${index}`}>{test.name}</li>
                    )}

                    {props.centerRequiresQfg && (
                        <li>QuantiFERON-TB Gold *This test is not ran by the NKR lab due to specimen handling requirements.</li>
                    )}
                </ol>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default SerologyTests;